package app.smartcoding.realrate.platform

import app.smartcoding.realrate.domain.model.AuthUser
import app.smartcoding.realrate.domain.model.SettingsState
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore

actual suspend fun loadUserSettings(
    authUser: AuthUser.User,
    onSuccess: (SettingsState) -> Unit,
    onFailed: (Throwable) -> Unit
) {
    try {
        val document = Firebase
            .firestore
            .collection("user-settings")
            .document(authUser.uid)
            .get()

        if (document.exists) {
            val settings = document.data<SettingsState>()
            onSuccess(settings)
        } else {
            onFailed(Exception("Settings not found"))
        }
    } catch (e: Exception) {
        onFailed(e)
    }
}